module.exports = __webpack_public_path__ + "static/media/newark-basin.86a7ffcc.jpg";